import { MarketAwardSource } from 'src/domain/caiso/cmri/interface';

export const MarketAwardSourceTag = ({ source }: { source: MarketAwardSource }) => {
    switch (source) {
        case MarketAwardSource.DAM:
            return <div title="Day-Ahead Market">DAM</div>;
        case MarketAwardSource.RTD:
            return <div title="Real-Time Dispatch">RTD</div>;
        case MarketAwardSource.FMM:
            return <div title="Fifteen Minutes Market">FMM</div>;
        default:
            return <></>;
    }
};
